module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-page landing-page"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "landing-page-wrapper contact-hero"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "landing-page-section"
  }, [_c('div', {
    staticClass: "landing-page-hero"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "landing-page-title color-1-100"
  }, [_vm._v("\n              " + _vm._s(_vm.content.heroSection.title) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "landing-page-title color-1-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-description color-2-77"
  }, [_vm._v("\n              " + _vm._s(_vm.content.heroSection.description) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "landing-page-description color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-contact-data"
  }, [_c('div', {
    staticClass: "landing-page-contact-data__inner"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('h2', {
    staticClass: "color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12 19.998"
    },
    attrs: {
      "version": "1.1",
      "id": "icons",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12 19.998",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M6,17.562C8.403,14.679,12,9.737,12,6c0-3.309-2.691-6-6-6S0,2.691,0,6C0,9.738,3.599,14.68,6,17.562z M6,2\n                          c2.206,0,4,1.794,4,4c0,2.507-2.438,6.294-4.001,8.382C4.437,12.296,2,8.51,2,6C2,3.794,3.794,2,6,2z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "6",
      "cy": "6",
      "r": "2"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "st0",
    attrs: {
      "x": "2",
      "y": "17.998",
      "width": "8",
      "height": "2"
    }
  })])]), _vm._v("\n                  Address\n                ")]), _vm._v(" "), (!_vm.pageEditMode) ? _c('span', {
    staticClass: "contact-info color-2-77"
  }, [_vm._v("\n                  " + _vm._s(_vm.content.contactsSection.address) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactsSection.address),
      expression: "content.contactsSection.address"
    }],
    staticClass: "contact-info color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Address",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contactsSection.address)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contactsSection, "address", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.contactsSection.address))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contacts"
  }, [_c('div', {
    staticClass: "email"
  }, [_c('h2', {
    staticClass: "color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 20 13"
    },
    attrs: {
      "version": "1.1",
      "id": "icons",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 13",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M18,0H2C0.897,0,0,0.898,0,2v9c0,1.102,0.897,2,2,2h16c1.103,0,2-0.898,2-2V2C20,0.898,19.103,0,18,0z\n                         M16.113,2L10,5.821L3.887,2H16.113z M2,11V3.179l7.47,4.669C9.632,7.949,9.816,8,10,8s0.368-0.051,0.53-0.152L18,3.179L18.001,11H2\n                        z"
    }
  })]), _vm._v("\n                    Email\n                  ")]), _vm._v(" "), (!_vm.pageEditMode) ? _c('span', {
    staticClass: "contact-info color-2-77"
  }, [_vm._v("\n                    " + _vm._s(_vm.content.contactsSection.email) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactsSection.email),
      expression: "content.contactsSection.email"
    }],
    staticClass: "contact-info color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Email",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contactsSection.email)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contactsSection, "email", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.contactsSection.email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_c('h2', {
    staticClass: "color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 19 19"
    },
    attrs: {
      "version": "1.1",
      "id": "icons",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 19 19",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M17,11h-4c-1.077,0-1.958,0.855-1.998,1.922c-2.543-0.404-4.473-2.341-4.909-4.925C7.152,7.95,8,7.073,8,6V2\n                        c0-1.103-0.897-2-2-2H2C0.897,0,0,0.897,0,2v5c0,6.617,5.383,12,12,12h5c1.103,0,2-0.897,2-2v-4C19,11.897,18.103,11,17,11z M12,17\n                        C6.486,17,2,12.515,2,7V2h4v4H5C4.732,6,4.475,6.107,4.287,6.298C4.099,6.49,3.996,6.748,4,7.016C4.072,11.567,7.512,15,12,15\n                        c0.552,0,1-0.448,1-1v-1h4l0.001,4H12z"
    }
  })]), _vm._v("\n                    Telephone\n                  ")]), _vm._v(" "), (!_vm.pageEditMode) ? _c('span', {
    staticClass: "contact-info color-2-77"
  }, [_vm._v("\n                    " + _vm._s(_vm.content.contactsSection.phone) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactsSection.phone),
      expression: "content.contactsSection.phone"
    }],
    staticClass: "contact-info color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Telephone",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contactsSection.phone)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contactsSection, "phone", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.contactsSection.phone))]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-wrapper contact-summary"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "landing-page-section"
  }, [_c('div', {
    staticClass: "landing-page-summary"
  }, [(!_vm.pageEditMode) ? _c('h2', {
    staticClass: "landing-page-summary__title background-1-10-before color-1-100"
  }, [_vm._v("\n              " + _vm._s(_vm.content.formSection.title) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.formSection.title),
      expression: "content.formSection.title"
    }],
    staticClass: "landing-page-summary__title color-1-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.formSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.formSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.formSection.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-contact-form"
  }, [(!_vm.formStatus.success) ? [_c('div', {
    staticClass: "contact-form-group required",
    class: [{
      'active': _vm.formData.name.text !== '' || _vm.formData.name.focus,
      'has-error': this.errors.has('Name')
    }]
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name.text),
      expression: "formData.name.text"
    }],
    staticClass: "contact-form-input",
    class: [{
      'border-1-50': _vm.formData.name.text !== '' || _vm.formData.name.focus
    }],
    attrs: {
      "id": "name",
      "name": "Name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.name.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.name.focus = true
      },
      "blur": function($event) {
        _vm.formData.name.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.name, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact-form-group required",
    class: [{
      'active': _vm.formData.surname.text !== '' || _vm.formData.surname.focus,
      'has-error': this.errors.has('Surname')
    }]
  }, [_c('label', {
    attrs: {
      "for": "surname"
    }
  }, [_vm._v("Surname")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.surname.text),
      expression: "formData.surname.text"
    }],
    staticClass: "contact-form-input",
    class: [{
      'border-1-50': _vm.formData.surname.text !== '' || _vm.formData.surname.focus
    }],
    attrs: {
      "id": "surname",
      "name": "Surname",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.surname.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.surname.focus = true
      },
      "blur": function($event) {
        _vm.formData.surname.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.surname, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact-form-group required",
    class: [{
      'active': _vm.formData.email.text !== '' || _vm.formData.email.focus,
      'has-error': this.errors.has('Email')
    }]
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.email.text),
      expression: "formData.email.text"
    }],
    staticClass: "contact-form-input",
    class: [{
      'border-1-50': _vm.formData.email.text !== '' || _vm.formData.email.focus
    }],
    attrs: {
      "id": "email",
      "name": "Email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.email.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.email.focus = true
      },
      "blur": function($event) {
        _vm.formData.email.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.email, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact-form-group required",
    class: [{
      'active': _vm.formData.phone.text !== '' || _vm.formData.phone.focus,
      'has-error': this.errors.has('Telephone')
    }]
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Telephone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.phone.text),
      expression: "formData.phone.text"
    }],
    staticClass: "contact-form-input",
    class: [{
      'border-1-50': _vm.formData.phone.text !== '' || _vm.formData.phone.focus
    }],
    attrs: {
      "id": "phone",
      "name": "Telephone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.phone.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.phone.focus = true
      },
      "blur": function($event) {
        _vm.formData.phone.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.phone, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact-form-group required",
    class: [{
      'active': _vm.formData.company.text !== '' || _vm.formData.company.focus,
      'has-error': this.errors.has('Company')
    }]
  }, [_c('label', {
    attrs: {
      "for": "company"
    }
  }, [_vm._v("Company name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.company.text),
      expression: "formData.company.text"
    }],
    staticClass: "contact-form-input",
    class: [{
      'border-1-50': _vm.formData.company.text !== '' || _vm.formData.company.focus
    }],
    attrs: {
      "id": "company",
      "name": "Company",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.company.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.company.focus = true
      },
      "blur": function($event) {
        _vm.formData.company.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.company, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact-form-group",
    class: [{
      'active': _vm.formData.industry.text !== '' || _vm.formData.industry.focus,
      'has-error': this.errors.has('Industry')
    }]
  }, [_c('label', {
    attrs: {
      "for": "industry"
    }
  }, [_vm._v("Industry")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.industry.text),
      expression: "formData.industry.text"
    }],
    staticClass: "contact-form-input",
    class: [{
      'border-1-50': _vm.formData.industry.text !== '' || _vm.formData.industry.focus
    }],
    attrs: {
      "id": "industry",
      "name": "Industry",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.industry.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.industry.focus = true
      },
      "blur": function($event) {
        _vm.formData.industry.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.industry, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact-form-group",
    class: [{
      'active': _vm.formData.employees.text !== '' || _vm.formData.employees.focus
    }]
  }, [_c('label', {
    attrs: {
      "for": "employees"
    }
  }, [_vm._v("Approximate number of employees")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.employees.text),
      expression: "formData.employees.text"
    }],
    staticClass: "contact-form-input",
    class: [{
      'border-1-50': _vm.formData.employees.text !== '' || _vm.formData.employees.focus
    }],
    attrs: {
      "id": "employees",
      "name": "Employees",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.employees.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.employees.focus = true
      },
      "blur": function($event) {
        _vm.formData.employees.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.employees, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact-form-group textarea",
    class: [{
      'active': _vm.formData.message.text !== '' || _vm.formData.message.focus
    }]
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.message.text),
      expression: "formData.message.text"
    }],
    staticClass: "contact-form-textarea",
    class: [{
      'border-1-50': _vm.formData.message.text !== '' || _vm.formData.message.focus
    }],
    attrs: {
      "id": "message",
      "name": "Message"
    },
    domProps: {
      "value": (_vm.formData.message.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.message.focus = true
      },
      "blur": function($event) {
        _vm.formData.message.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.message, "text", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.formData.message.text))])]), _vm._v(" "), _c('div', {
    staticClass: "contact-form-info"
  }, [_c('p', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Fields marked with * are mandatory.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Privacy:")]), _vm._v(" Your details will be used to keep you informed about resources provided by The Clear Company.\n                  "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy-policy'
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" to find out more about the services we provide.\n                ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "contact-form-actions"
  }, [_c('div', {
    staticClass: "subscribe"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.subscribe),
      expression: "formData.subscribe"
    }],
    attrs: {
      "type": "checkbox",
      "aria-hidden": "true",
      "tabindex": "-1",
      "id": "subscribe"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.subscribe) ? _vm._i(_vm.formData.subscribe, null) > -1 : (_vm.formData.subscribe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formData.subscribe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formData, "subscribe", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formData, "subscribe", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formData, "subscribe", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "subscribe",
      "tabindex": "0"
    }
  }, [_vm._v("Subscribe me to the newsletter")])]), _vm._v(" "), _c('a', {
    staticClass: "submit background-1-20 background-1-60-hover",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitContactForm()
      }
    }
  }, [_vm._v("Submit message")])]), _vm._v(" "), _c('div', {
    staticClass: "contact-form-message",
    class: !_vm.formStatus.success || this.errors.items ? 'error' : 'success',
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.formStatus.submitting) ? _c('div', {
    staticClass: "visually-hidden"
  }, [_vm._v("\n                  Submitting\n                ")]) : [(this.errors.items && this.errors.items.length) ? [_c('h2', [_vm._v("Something went wrong.")]), _vm._v(" "), _c('ul', _vm._l((this.errors.items), function(error) {
    return _c('li', [_vm._v("\n                        " + _vm._s(error.msg) + "\n                      ")])
  }), 0)] : _vm._e(), _vm._v(" "), (_vm.formStatus.shown) ? [(_vm.formStatus.title !== '') ? _c('h2', [_vm._v(_vm._s(_vm.formStatus.title))]) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v(_vm._s(_vm.formStatus.body))]) : _vm._e()] : _vm._e()]], 2)] : _vm._e()], 2)])])])]), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cebcd00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Contact.vue
// module id = 906
// module chunks = 1